<template>
  <WsMain>
    <WsCRUD
      ref="WsCRUD"
      orderWay="asc"
      orderBy="sequence"
      :label="label"
      :fields="fields"
      :isCreatable="false"
      :inRowBtnRead="false"
      :modelName="modelName"
      :inRowBtnDelete="false"
      :showFields="showFields"
      :filterSelects="filterSelects"
      :customUpdateAction="customUpdateAction"
    >
      <template v-slot:titlebarCustomBtns>
        <WsBtn
          minWidth="100px"
          @click="$_onImportOpen"
        >
          匯入
        </WsBtn>
        <WsBtn
          minWidth="100px"
          class="ml-2"
          @click="$_onExportOpen"
        >
          匯出
        </WsBtn>
      </template>
    </WsCRUD>
    <WsImportDialog
      ref="importDialog"
      :label="label"
      :fields="importFields"
      @create-submit="$_onImport($event)"
    />
    <LvExportDialog
      ref="exportDialog"
      label="匯出翻譯"
      fileName="translation"
      exportUrl="/export/translation/url"
      :fields="exportFields"
    />
  </WsMain>
</template>

<script>
import model from '@/models/translation';
import Spare_module from '@/spare/module';

export default {
  data() {
    return {
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      importFields: {
        content_text: {
          type: 'file',
          label: '翻譯 (檔案格式限制: xlsx)',
          uploadUrl: '/import/translation',
          maxWidth: '100px',
          accept: '.xlsx',
          rules: 'required',
        },
      },
      exportFields: {
        for: {
          type: 'select',
          label: '適用前後台',
          items: [
            {
              text: '前台',
              value: 'app',
            },
            {
              text: '後台',
              value: 'platform',
            },
          ],
        },
        topic: {
          type: 'hasMany',
          label: '主題',
          modelName: 'topic',
          rules: 'required',
        },
        locale: {
          type: 'hasMany',
          label: '語言',
          modelName: 'locale',
        },
        module: {
          type: 'select',
          label: '模組',
          readonly: true,
          items: Spare_module.list,
        },
      },
      showFields: [
        'sequence',
        'content_text',
        'text',
        'topic',
        'module',
        'locale',
        'lang',
        'for',
        'updated_at',
        'updated_admin',
      ],
      filterSelects: [
        {
          type: 'belongsTo',
          textKey: 'name',
          modelName: 'topic',
          placeholder: '請選擇主題',
        },
        {
          type: 'select',
          label: '適用前後台',
          items: [
            {
              text: '前台',
              value: 'app',
            },
            {
              text: '後台',
              value: 'platform',
            },
          ],
          paramName: 'for',
          placeholder: '請選擇適用前後台',
        },
        {
          type: 'select',
          label: '模組',
          items: Spare_module.list,
          paramName: 'module',
          placeholder: '請選擇模組',
        },
      ],
    };
  },
  methods: {
    customUpdateAction({sequence, text}) {
      return {
        sequence,
        text,
      };
    },
    $_onImportOpen() {
      this.$refs.importDialog.open();
    },
    async $_onImport($event) {
      this.$refs.importDialog.startLoading();
      try {
        await this.$axios.post(
          `${$event.uploadUrl}`,
          $event.formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        this.$refs.importDialog.stopLoading();
        this.$refs.importDialog.close();
        await this.$refs.WsCRUD.$_fetchData();
      } catch (error) {
        alert(error)
      } finally {
        this.$refs.importDialog.stopLoading();
      }
    },
    $_onExportOpen() {
      this.$refs.exportDialog.open();
    },
  },
};
</script>